import { defineMessages } from 'react-intl'

const DiscoverRouteMessages = {
  messages: defineMessages({
    heading: {
      id: 'route.landing.dicoverroute',
      defaultMessage: 'Discover A New Route',
    },
    button: {
      id: 'route.landing.searchroutes',
      defaultMessage: 'Search Routes',
    },
  }),
  icons: [
    {
      name: 'ic-search',
      message: defineMessages({
        definition: {
          id: 'route.landing.searchspecifics',
          defaultMessage: 'Search Specifics',
        },
      }),
    },
    {
      name: 'ic-popular',
      message: defineMessages({
        definition: {
          id: 'route.landing.findpopularroutes',
          defaultMessage: 'Find Popular Routes',
        },
      }),
    },
    {
      name: 'ic-bookmark',
      message: defineMessages({
        definition: {
          id: 'route.landing.saveyourfavorites',
          defaultMessage: 'Save Your Favorites',
        },
      }),
    },
  ],
}

export default DiscoverRouteMessages

